<template>
  <div
    class="comment-container"
    :style="getCommentStyle"
  >
    <iframe :style="getCommentTagStyle" :src="iframeSrc" frameborder="0" :scrolling="iframeScrollStatus == true ? 'auto' : 'no'"></iframe>
    <div class="comment-shadow" v-if="!isBigScreenPreview()"></div>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
export default {
  mixins: [eventMixin],
  name: "cxComment",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    },
    isGridItem: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      myplayer: null,
      isError: false,
      commentShadowStatus: false
    }
  },
  mounted() {
    console.log("aaaa",this.$store.state.states.getDataPageIds.dataId)
  },
  beforeDestroy() {},
  destroyed() {},
  computed: {
    ids() {
      return this.myid
    },
    iframeSrc(){
      const pageType = this.$store.state[this.request_prefix].type
      const  {pageId,dataId } = this.$store.state.states.getDataPageIds
      const webSiteId =  this.$store.state.states.myCookie?.website_id
      let relativeId = pageType === 'detailPage' ? dataId : pageId
      relativeId = this.md5(relativeId)+"0000"
      const productName = `mh-${webSiteId}`
      const defaultSrc = `https://fe.chaoxing.com/comp/comment/iframe/comment.html?relationId=${relativeId}&productName=${productName}&showStar=true&imgviewer=true&forward=true`
      return defaultSrc
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (!this.options.textPaddingTypeFlag || this.options.textPaddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          // tmpStyle += `${this.options.boxShadowH[index]}px ${this.options.boxShadowV[index]}px ${this.options.boxShadowBlur[index]}px ${this.options.boxShadowSpread[index]}px ${this.options.boxShadowColor[index]}`
          tmpStyle += `${this.options.boxShadowH[index]}px ${this.options.boxShadowV[index]}px ${this.options.boxShadowBlur[index]}px ${this.options.boxShadowSpread[index]}px ${this.$parseColor(this.options.boxShadowColor[index])}`
        })
      } else {
        // tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.options.boxShadowColor}`
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.bgIsThemeColor || false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    getCommentTagStyle(){
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      return {
        ...this.bgStyle,
        padding: this.getPaddingStyle,
        "box-shadow": this.boxShadowStyle,
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor && this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": this.options.showBorder !== false ? borderW : 0,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px"
      }
    },
    getCommentStyle() {
      const { width, widthType, height, heightType, top, left } = this.options
      return {
        width: this.isGridItem ? '100%' : `${width}${widthType}`,
        height: this.isGridItem ? '100%' : `${height}${heightType}`,
      }
    },
    iframeScrollStatus() {
      return this.options.iframeScrollStatus
    },
    noCacheComponent() {
      return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
    }
  },
  watch: {},
  methods: {}
}
</script>

<style scoped>
.overflowHidMultiLines {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.comment-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.comment-container > iframe {
  width: 100%;
  height: 100%;
}
.comment-container > iframe::-webkit-scrollbar {
  display: none;
}
.comment-shadow {
  position: absolute;
  top: 0;
  left: 0;
  right: 20px;
  bottom: 20px;
  z-index: 2;
}
</style>
